<template>
  <div class="allOrder" :style="listHeight">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      v-if="list.length != 0"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell class="lists" v-for="(item, index) in list" :key="index">
          <div @click="detail(item.ordersn)" v-if="item.list_extend">
            <div class="item" v-if="!item.list_extend.refund">
              <span class="item-number">订单号：{{ item.ordersn }}</span>
              <span class="item-tips close" v-if="item.list_extend.status == -1"
                >已关闭</span
              >
              <span class="item-tips" v-if="item.list_extend.status == 1"
                >待付款</span
              >
              <span class="item-tips" v-if="item.list_extend.status == 2"
                >正参与</span
              >
              <span class="item-tips" v-if="item.list_extend.status == -2"
                >已退股</span
              >
            </div>
            <div class="item" v-if="item.list_extend.refund">
              <span class="item-number">订单号：{{ item.ordersn }}</span>
              <span class="item-tips" v-if="item.list_extend.refund.status == 1"
                >退股申请</span
              >
              <span class="item-tips" v-if="item.list_extend.refund.status == 2"
                >待退股</span
              >
              <span class="item-tips" v-if="item.list_extend.refund.status == 3"
                >退股中</span
              >
              <span class="item-tips" v-if="item.list_extend.refund.status == 4"
                >已退股</span
              >
              <span
                class="item-tips"
                v-if="item.list_extend.refund.status == -1"
                >申请驳回</span
              >
              <span
                class="item-tips"
                v-if="item.list_extend.refund.status == -2"
                >审核驳回</span
              >
              <span
                class="item-tips"
                v-if="item.list_extend.refund.status == -3"
                >退股失败</span
              >
            </div>
            <div class="item-i" v-if="item.list_extend">
              <div class="item_l">
                <img :src="item.list_extend.project.poster" @error="nofind()" />
              </div>
              <div class="item_r">
                <p class="item-title">
                  {{ item.list_extend.project.project_name }}
                </p>
                <p>
                  股数：{{ item.list_extend.shares }}股 每股单价：¥{{
                    item.list_extend.project.share_price
                  }}
                </p>
                <p>
                  总价：<span>¥{{ item.actual_amount }}</span>
                </p>
              </div>
            </div>
          </div>
          <div
            class="btn"
            v-if="item.list_extend && item.list_extend.status == 1"
          >
            <span class="cancel" @click="showPopup(item.ordersn, index)"
              >取消订单</span
            >
            <span class="pay" @click="Pay(item)">立即付款</span>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="show">
      <div class="box">
        <img src="../../assets/common/BG@2x.png" alt="" />
        <p class="title">温馨提示</p>
        <p class="tips">亲，您真的要取消该订单吗？</p>
        <span class="left" @click="cancle()">取消</span>
        <span class="right" @click="confirm()">确认</span>
      </div>
    </van-popup>
    <van-row class="empty" v-if="list.length == 0 && !hasList">
      <van-col class="emptyMsg" span="24">
        <img src="../../assets/myInvest/empty.png" />
        <p class="tip">暂无相关众筹</p>
      </van-col>
    </van-row>
    <div class="loading" v-if="list.length <= 0 && hasList">
      <img src="../../assets/common/loading.gif" />
    </div>
  </div>
</template>
<script>
import defaultImg from "@/assets/common/compare.png";
export default {
  props: {
    orderStyle: {
      type: String,
      detault: "0",
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      show: false,
      cancleOrderSn: 0,
      cancleIndex: 0,
      orderInfo: {},
      isiOSX: false,
      listHeight: {
        height: document.body.clientHeight - 68 + "px",
        padding: "39px 16px 50px",
      },
      hasList: true,
    };
  },
  created() {
    this.getInfo();
    this.isiOSX = this.isIphoneX();
    if (this.isiOSX) {
      this.listHeight.height = document.body.clientHeight - 88 + "px";
    }
    if (this.$route.query.from == 1) {
      this.listHeight.padding = "39px 16px 0";
    }
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
      //    setTimeout(() => {
      //      this.$toast('刷新成功');
      //      this.isLoading = false;
      //    }, 500);
    },
    getInfo() {
      this.$api
        .post("/order/member/order/list", {
          page: this.page,
          status: this.orderStyle,
          type: "investment",
        })
        .then((res) => {
          this.allList = res.total;
          //		        if(this.page = 1) {
          //		        	this.list = [];
          //		        }
          if (res.list.length == 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
            this.timeout = true;
          } else {
            this.$toast(message);
          }
        });
    },
    detail(ordersn) {
      this.$router.push({
        path: "/myInvest/full",
        query: {
          ordersn: ordersn,
        },
      });
    },
    showPopup(ordersn, index) {
      this.show = true;
      this.cancleOrderSn = ordersn;
      this.cancleIndex = index;
    },
    cancle() {
      this.show = false;
    },
    confirm() {
      this.show = false;
      this.$api
        .post("/order/member/order/cancel", { ordersn: this.cancleOrderSn })
        .then((res) => {
          //this.list[this.cancleIndex].list_extend.status = -1;
          var length = this.page;
          this.list = [];
          this.page = 0;
          for (var j = 0; j < length; j++) {
            this.page = j + 1;
            this.getInfo();
          }
        });
    },
    Pay(item) {
      this.orderInfo = {
        actual_amount: item.actual_amount,
        deduct_coin: item.deduct_coin,
        deduct_credits: item.deduct_credits,
        master_order_sn: "",
        order_amount: item.order_amount,
        ordersn: item.ordersn,
      };
      this.investPay();
    },
    investPay() {
      this.params(
        JSON.stringify(this.orderInfo),
        JSON.stringify(this.orderInfo),
        "investPay"
      );
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
  },
};
</script>
<style lang="less">
.allOrder {
  background-color: #f2f2f2;
  min-height: 100%;
  box-sizing: border-box;
  .van-popup--center {
    width: 70%;
    border-radius: 10px;
    .box {
      img {
        display: block;
        width: 100%;
      }
      .title {
        color: #333;
        font-size: 15px;
        font-weight: 600;
        line-height: 47px;
        margin-top: 8px;
        text-align: center;
      }
      .tips {
        color: #333;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
        margin-bottom: 30px;
      }
      span {
        float: left;
        width: 50%;
        border-top: solid 1px #f2f2f2;
        line-height: 43px;
        color: #999;
        font-size: 14px;
        text-align: center;
        // display: inline-block;
      }
      .right {
        color: #e6212f;
        width: calc(50% - 1px);
        border-left: solid 1px #f2f2f2;
      }
    }
  }
  .empty {
    padding-top: 100px;
    .emptyMsg {
      text-align: center;
      img {
        width: 106px;
        display: inline-block;
      }
      .tip {
        color: #cccccc;
        font-size: 14px;
        margin-top: 17px;
        height: 20px;
        line-height: 20px;
      }
    }
  }
  .loading {
    width: 100%;
    /*padding-top: 100px;*/
    text-align: center;
    img {
      width: 35%;
      margin-top: 50%;
    }
  }
}
</style>
<style scoped>
.all .van-pull-refresh {
  height: 100%;
  box-sizing: border-box;
  padding-top: 21px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.all .lists {
  padding-bottom: 12px;
  border-radius: 5px;
  background: #fff;
  padding: 10px 0 12px;
  margin-bottom: 16px;
}
.all .lists .item {
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
  line-height: 43px;
  padding-right: 72px;
  position: relative;
}
.all .lists .item span {
  display: inline-block;
}
.all .lists .item .item-number {
  font-size: 13px;
  color: #555555;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
}
.all .lists .item .item-tips {
  font-size: 14px;
  color: #c49e80;
  position: absolute;
  top: 0;
  right: 12px;
}
.all .lists .item .close {
  color: #999;
}
.item-i {
  display: flex;
  padding: 13px 12px 0;
}
.item_l {
  width: 80px;
  height: 60px;
  background: #f5f5f5;
  margin-right: 8px;
}
.item_l img {
  width: 100%;
  height: 100%;
  border-radius: 3px;
}
.item_r {
  width: calc(100% - 88px);
}
.item_r p {
  margin-top: 8px;
  font-size: 12px;
  color: #999999;
  font-weight: 400;
  line-height: 12px;
}
.item_r .item-title {
  margin-top: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #333333;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.btn {
  display: flex;
  justify-content: flex-end;
  padding: 0 12px;
  margin-top: 16px;
}
.btn span {
  width: 72px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 14px;
  font-size: 14px;
  color: #999999;
}
.btn .cancel {
  border: 1px solid #979797;
  margin-right: 12px;
}
.btn .pay {
  border: 1px solid #d29a6e;
  color: #d29a6e;
}
</style>


